import {
  AddDomainIcon,
  Box,
  CleanButton,
  List,
  ListItem,
  Spacing,
  Stack,
  styled,
  Typography,
} from 'ui';

export const StyledItemLoader = styled(ListItem)`
  border-top: 1px solid;
  border-color: ${({ theme }) => theme.palette.neutral[200]};
  display: flex;
  justify-content: center;
`;

export const StyledList = styled(List)`
  overflow-y: auto;
  flex: 1;
`;

export const ContainerStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'usersList',
})<{ usersList?: boolean }>`
  gap: ${({ theme, usersList }) =>
    usersList ? theme.spacing(Spacing.Medium) : theme.spacing(Spacing.None)};
`;

export const StyledButton = styled(CleanButton)`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  justify-content: center;
`;

export const StyledIcon = styled(AddDomainIcon)`
  width: 34px;
  height: 34px;
`;

export const StyledFontTypography = styled(Typography)`
  font-weight: bold;
`;

export const StyledBox = styled(Box)`
  .MuiCheckbox-root {
    padding: 0;
    padding-right: 0;
  }
  .MuiCheckbox-root:hover {
    background-color: transparent;
  }
`;

export const ListContainer = styled(Stack)<{ usersList?: boolean }>`
  flex: 1;
  gap: ${({ theme, usersList }) =>
    usersList ? theme.spacing(Spacing.Medium) : theme.spacing(Spacing.None)};
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Medium)};
`;

export const FieldContainer = styled(Stack)`
  margin-bottom: ${({ theme }) => theme.spacing(Spacing.Medium)};
`;
